<template>
  <v-card v-bind="$attrs">
    <v-app-bar dark color="primary">
      <v-toolbar-title>{{ tank.tankName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <span v-if="currentTankStatus">
        {{
          currentTankStatus.statusDateTimeLt | removeTAndSecondsAndFormatDate
        }}
      </span>
    </v-app-bar>
    <div
      :class="notTankDetailsRoute ? 'card-body' : ''"
      @click="notTankDetailsRoute ? tankDetails(tank) : null"
    >
      <v-progress-circular
        class="text-h4 my-8"
        :rotate="-90"
        :size="progressCircleSize"
        :width="progressCircleWidth"
        :value="fillPercent"
        :color="getProgressColourByFillPercent(fillPercent)"
      >
        <span class="text-h3">{{ fillPercent }}%</span>
      </v-progress-circular>
    </div>
    <div class="py-0 px-4 mt-4">
      <v-divider />
      <div class="d-flex justify-space-between text-body-1 my-1">
        <span class="d-block text-truncate font-weight-bold bulk">{{
          currentTankStatus ? currentTankStatus.bulk : tank.bulkName
        }}</span>
        <span v-if="currentTankStatus" class="quantity">
          {{ quantityOnBoard }}/{{ tank.maxCapacity }}
          {{ tank.qtyUom }}
        </span>
        <span v-else>No Status Found</span>
      </div>
      <v-divider />
    </div>
    <v-card-actions v-if="!disableCardActions" class="">
      <v-btn
        class="background elevation-0"
        small
        @click="onUpdateTankStatusClicked(tank)"
        :disabled="disableUpdateStatus"
        >Update Status</v-btn
      >
      <v-btn
        v-if="notTankDetailsRoute"
        class="background elevation-0"
        small
        @click="tankDetails(tank)"
        >Details</v-btn
      >
      <v-spacer></v-spacer>
      <SyncStateIcon
        v-if="isAnyUnsyncedStatuses"
        :isItemUnsynced="isUnsynced"
      ></SyncStateIcon>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import TankStatusMixin from '../../mixins/TankStatusMixin';
import SyncStateIcon from '../ui/SyncStateIcon.vue';

export default {
  name: 'TankStatusCard',
  inheritAttrs: false,
  components: { SyncStateIcon },
  mixins: [TankStatusMixin],
  props: {
    tank: {
      type: Object,
      required: true,
    },
    disableCardActions: {
      type: Boolean,
      required: false,
      default: false,
    },
    onUpdateTankStatusClicked: {
      type: Function,
      required: false,
    },
    progressCircleSize: {
      type: Number,
      required: false,
      default: 225,
    },
    progressCircleWidth: {
      type: Number,
      required: false,
      default: 35,
    },
  },
  computed: {
    ...mapGetters({
      isTankAdmin: 'userStore/isTankAdmin',
    }),
    currentTankStatus() {
      return this.tank.currentTankStatus;
    },
    fillPercent() {
      return this.currentTankStatus ? this.currentTankStatus.fillPercent : 0;
    },
    quantityOnBoard() {
      return this.currentTankStatus ? this.currentTankStatus.quantityOnBoard.toFixed(2) : 0;
    },
    notTankDetailsRoute() {
      return this.$route.name !== 'tankDetails';
    },
    isUnsynced() {
      return (this.tank.idc !== null && this.tank.idc !== undefined);
    },
    disableUpdateStatus() {
      return !this.isTankAdmin;
    },
  },
  methods: {
    tankDetails(tank) {
      this.$router.push({ name: 'tankDetails', params: { id: tank.id } });
    },
  },
};
</script>
<style scoped>
.card-body {
  cursor: pointer;
  -moz-transition: all 0.4s ease-in;
  -o-transition: all 0.4s ease-in;
  -webkit-transition: all 0.4s ease-in;
  transition: all 0.4s ease-in;
}
.card-body:hover {
  background-color: #2196f350;
}

.quantity {
  text-align: end;
  flex: 1;
}

.bulk {
  text-align: start;
  flex: 1;
}
</style>
